var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableDownload)?_c('div',{attrs:{"id":"image"}},[_c('product-qr-ui',{attrs:{"product":_vm.product,"qrCodeValue":_vm.qrCodeValue,"borders":false,"isPdf":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }